var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.75C5.275 13.75 3.772 13.1782 2.491 12.0347C1.21 10.8912 0.4755 9.463 0.2875 7.75H1.825C2 9.05 2.57825 10.125 3.55975 10.975C4.54125 11.825 5.688 12.25 7 12.25C8.4625 12.25 9.70325 11.7407 10.7222 10.7222C11.7412 9.70375 12.2505 8.463 12.25 7C12.2495 5.537 11.7402 4.2965 10.7222 3.2785C9.70425 2.2605 8.4635 1.751 7 1.75C6.1375 1.75 5.33125 1.95 4.58125 2.35C3.83125 2.75 3.2 3.3 2.6875 4H4.75V5.5H0.25V1H1.75V2.7625C2.3875 1.9625 3.16575 1.34375 4.08475 0.90625C5.00375 0.46875 5.9755 0.25 7 0.25C7.9375 0.25 8.81575 0.42825 9.63475 0.78475C10.4537 1.14125 11.1663 1.62225 11.7723 2.22775C12.3783 2.83325 12.8595 3.54575 13.216 4.36525C13.5725 5.18475 13.7505 6.063 13.75 7C13.7495 7.937 13.5715 8.81525 13.216 9.63475C12.8605 10.4542 12.3793 11.1668 11.7723 11.7723C11.1653 12.3778 10.4527 12.859 9.63475 13.216C8.81675 13.573 7.9385 13.751 7 13.75ZM9.1 10.15L6.25 7.3V3.25H7.75V6.7L10.15 9.1L9.1 10.15Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.075818c30c695ceefa6f81e12e0bebe4.svg";
export { ForwardRef as ReactComponent };